import React from "react";
import { Box, Skeleton, Grid, Typography } from "@mui/material";

const SkeletonDoughnutChart: React.FC<{title: string}> = ({ title }) => {
  return (
    <>
      <Typography fontWeight={500} sx={{ mb: 5 }}>{title}</Typography>
      <Box sx={{ display: "flex", alignItems: "center", gap: 4 }}>
        <Box
          sx={{
            position: "relative",
            width: "250px",
            height: "250px",
            flexShrink: 0,
          }}
        >
          <Skeleton
            variant="circular"
            sx={{
              width: "100%",
              height: "100%",
              backgroundColor: "#E0E0E0",
            }}
          />
          <Skeleton
            variant="rectangular"
            width="50px"
            height="50px"
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              backgroundColor: "#BDBDBD",
            }}
          />
        </Box>

        <Box>
          <Grid container spacing={1} alignItems="center">
            <Grid item>
              <Skeleton
                variant="text"
                width={100}
                sx={{ backgroundColor: "#BDBDBD" }}
              />
            </Grid>

            <Grid item>
              <Skeleton
                variant="text"
                width={100}
                sx={{ backgroundColor: "#BDBDBD" }}
              />
            </Grid>

            <Grid item>
              <Skeleton
                variant="text"
                width={100}
                sx={{ backgroundColor: "#E0E0E0" }}
              />
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default SkeletonDoughnutChart;
